const AVI = [
    {
      page: 3,
      lib: "Première énigme !",
      texteIndice: ["Une plaque au mur sur un des bâtiments au nord de la place", "'Marché au bois et cocons' est inscrit sur la plaque", "'Cocons' a trop de lettres pour être la réponse, quelle est donc la matière à trouver ?", "Soie"]
    },
    {
      page: 5,
      lib: "La culture",
      texteIndice: [
        "Les lettres en gras du texte forment un indice",
        "La 'maison' de Mona Lisa se trouve proche du point 5 sur votre plan",
        "Le Louvre (Vous avez la galerie 'le petit Louvre' dans cette rue)"
      ]
    },
    {
      page: 8,
      lib: "Fenêtres grises de banque",
      texteIndice: [
        "Cherchez des fenêtres à fond gris, visibles depuis la place, en hauteur",
        "Derrière l'entrée de l'ancienne Banque de France, avec des dessins",
        "Parasol"
      ]
    },
    {
      page: 10,
      lib: "Mathématiques ?!",
      texteIndice: ["Pas besoin de regarder autour de vous pour cette énigme, lisez bien l'énigme",
        "Gardez les lettres",
        "ab - a = b",
        "Sacs"]
    },
    {
      page: 12,
      lib: "La gravure",
      texteIndice: [
        "Chantez maintenant",
        "Ces gens sont sur un pont",
        "La lettre 'd' (Chanson 'sur le pont d'Avignon, on y danse...')"
      ]
    },
    {
      page: 14,
      lib: "La vigne",
      texteIndice: [
        "Deux outils à combiner, déjà fournis",
        "Le stylo et la vigne",
        "Cage (Entourez le stylo)"
      ]
    },
    {
      page: 15,
      lib: "Le nom de la rue",
      texteIndice: [
        "Proche de la plaque",
        "Gravure sous plaque de rue",
        "Rue des Ciseaux d'Or"
      ]
    },
    {
      page: 17,
      lib: "Le blason",
      texteIndice: [
        "Éliminez les mauvaises",
        "Les mauvaises couleurs",
        "Forums"
      ]
    },
    {
      page: 19,
      lib: "Le blason",
      texteIndice: [
        "Formez un seul mot",
        "Un restaurant de la place",
        "Cloître"
      ]
    },
    {
      page: 21,
      lib: "Les clés",
      texteIndice: [
        "Outils fournis en plus du carnet",
        "Pliez les clés",
        "Boucherie"
      ]
    },
    {
      page: 23,
      lib: "La tour",
      texteIndice: [
        "Trouvez la tour, gardez les lettres rouges",
        "Lisez de haut en bas, des lettres se répètent",
        "Gênent"
      ]
    },
    {
      page: 26,
      lib: "Mots croisés",
      texteIndice: [
        "1: Clément",
        "2: Doms, 3: Salamandre",
        "Moustaches"
      ]
    },
    {
      page: 28,
      lib: "Indice",
      texteIndice: ["Cherchez à l'endroit", "Cadenas au niveau du poteau avec le mot 'combien' gravé", "Qui a des étoiles à proximité ?", "Trois (étoiles à l'hôtel)"]
    },
    {
      page: 30,
      lib: "Le jardin",
      texteIndice: [
        "Mélangez",
        "Jaune et bleu donnent du vert",
        "Jarre (car fond vert)"
      ]
    },
    {
      page: 33,
      lib: "Les Corps-Saints",
      texteIndice: ["On le trouve au coin d'une rue", "Statue en pierre en hauteur", "Pont (il tient un petit pont)"]
    },
    {
      page: 34,
      lib: "Joseph Roumanille",
      texteIndice: [
        "Son nom ou sa tête permettent de le retrouver facilement",
        "Où se trouve la 4ème de couverture pour un livre ? Alors pour une stèle ?",
        "Lis Oubreto (au dos de la stèle de Joseph Roumanille dans le square)"
      ]
    },
    {
      page: 36,
      lib: "English only",
      texteIndice: [
        "Trouvez dans le square un symbole anglais, qui en plus contient des livres",
        "'In front of it' signifie 'en face de'",
        "'Spirit' signifie 'Esprit'",
        "Prosper Mérimée"
      ]
    },
    {
      page: 99,
      lib_page: "Enigme finale de fin de parcours",
      lib: "Vous avez terminé le parcours ? Bravo ! Etes-vous digne de rejoindre la Confrérie Noire ?",
      lib_win_title: "Bravo ! Félicitations !",
      lib_win_texte: "Encore un grand merci d'avoir participé à l'un de nos jeux !",
      questions: ["* Votre réponse, le ... *"],
      answers: ["Pain"]
    },
        {
      page: 95,
      lib_page: "Indices pour l'énigme finale",
      lib: "Indices enigme finale",
      texteIndice: [
        "Plus je suis chaud, plus je suis frais. On me mange.",
        "Un aliment quotidien bien français.",
        "Que l'on peut manger le matin, le midi ou le soir."
      ]
    }
  ];

export default AVI;